<template>
  <v-container>
    <v-progress-circular
      indeterminate
      class="mx-auto"
    />
  </v-container>
</template>
